import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button} from 'views/components';
import {EditCalendar as EditCalendarIcon, Cancel as CancelIcon, ArrowBack as ArrowBackIcon} from 'views/icons';
import {Translate, useNavigate, getEventStatusStyles} from 'views/module';

const EventHeader = (props) => {
  const {event, setModel} = props;

  const navigate = useNavigate();

  const statusStyles = getEventStatusStyles({event});

  const handleCancelEvent = () => {
    setModel('CANCEL');
  };

  const handleRescheduleEvent = () => {
    setModel('RESCHEDULE');
  };

  return (
    <>
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        alignItems={{xs: 'flex-start', sm: 'center'}}
        justifyContent="space-between"
        mb={2}
        spacing={1}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{flexWrap: 'wrap', minWidth: 0}}
        >
          <ArrowBackIcon
            sx={{color: 'black', cursor: 'pointer', mr: 1}}
            onClick={() => {
              if (window.history.length > 1) {
                navigate(-1);
              } else {
                navigate('/schedule/client');
              }
            }}
          />
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            sx={{
              background: statusStyles.background,
              color: statusStyles.textColor,
              border: `1px solid ${statusStyles.borderColor}`,
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              fontSize: {xs: '12px', sm: '14px'},
              mr: 1,
              mb: {xs: 0.5, sm: 0},
              whiteSpace: 'nowrap',
            }}
          >
            {statusStyles.label}
          </Typography>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{
              fontSize: {xs: '1.1rem', sm: '1.25rem'},
              wordBreak: 'break-word',
              maxWidth: {xs: '180px', sm: 'none'},
              flexShrink: 1,
            }}
          >
            {event.info.title}
          </Typography>
        </Stack>
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          spacing={1}
          sx={{width: {xs: '100%', sm: 'auto'}, mt: {xs: 1, sm: 0}}}
        >
          <Button
            variant="outlined"
            color="black"
            startIcon={<EditCalendarIcon />}
            onClick={handleRescheduleEvent}
            sx={{width: {xs: '100%', sm: 'auto'}}}
          >
            <Translate expression='schedule.eventDetail.Header.RescheduleButton'/>
          </Button>
          <Button
            variant="outlined"
            color="error"
            startIcon={<CancelIcon />}
            onClick={handleCancelEvent}
            sx={{width: {xs: '100%', sm: 'auto'}}}
          >
            <Translate expression='schedule.eventDetail.Header.CancelButton'/>
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

EventHeader.propTypes = {
  event: PropTypes.object.isRequired,
  setModel: PropTypes.func.isRequired,
};

export default EventHeader;
